<template>
  <div class="p-5 flex flex-col">
    <p class="font-semibold text-3xl">
      {{ this.$route.meta.title }}
    </p>
    <vs-row
      vs-w="12"
      class="my-5 filter-container flex justify-between"
    >
      <vs-col vs-w="1">
        <p class="font-semibold">
          Filter
        </p>
      </vs-col>
      <vs-col vs-w="3" />
      <vs-col
        vs-w="8"
        class="flex justify-end"
      >
        <div class="flex flex-row gap-x-4 items-stretch">
          <div class="flex items-center w-full">
            <date-picker
              v-model="filters.month_year"
              type="month"
              format="MMM-YYYY"
              value-type="format"
              placeholder="Month-Year"
            />
          </div>
          <div class="flex items-center">
            <vs-button
              type="border"
              color="primary"
              class="self-center font-semibold"
              style="min-width: 100px"
              @click="resetFilters"
            >
              Reset
            </vs-button>
          </div>
        </div>
      </vs-col>
    </vs-row>
    <div class="p-5 flex flex-col mt-5 bg-white rounded-md">
      <table-top
        is-search-has-border
        :page-size-start="false"
        class="mt-5"
        @fetch="fetchBridgeSchedule"
        ref="tabletop"
      >
        <template #start>
          <div class="flex items-center justify-center gap-x-5">
            <!-- TODO: Add upload bridge schedule button -->
            <!-- <vs-button
              v-show="!isUserCanAccessMenu(permission.name, 'add')"
              class="button shadow-primary h-full"
              color="primary"
              @click="{}"
            >
              Upload Bridge Schedule
            </vs-button> -->
            <vs-button
              v-show="isUserCanAccessMenu(permission.name, 'add')"
              class="button shadow-primary h-full"
              type="border"
              color="primary"
              @click="startAdd"
            >
              Add New Bridge Schedule
            </vs-button>
            <vs-button
              class="button shadow-secondary"
              color="secondary"
              @click="isDownload = true"
              :disabled="isDownload"
            >
              Export Excel
            </vs-button>
          </div>
        </template>
      </table-top>
      <data-table
        class="my-5"
        :loading="isBusy"
        :table-header="tableHeaders"
        :table-data="bridgeScheduleData"
        :sort-by="filters.sort_by"
        :sort-dir="filters.sort_dir"
        @sort="sort"
      >
        <template #no="{ index }">
          <div class="flex flex-row w-min">
            {{ (currentPage - 1) * pageSize + index + 1 }}
          </div>
        </template>
        <template #action="{ row }">
          <div class="flex flex-row gap-x-3">
            <template v-if="row.isEditing">
              <div
                :class="`flex items-center justify-center icon-transparent-bg complete ${isProcessing && 'animate-bounce cursor-not-allowed opacity-50'}`"
                @click="isProcessing ? null : saveEdit(row)"
              >
                <img
                  :src="require('@/assets/shipo-icon-check-circle.svg')"
                  alt="save"
                >
              </div>
              <div
                :class="`flex items-center justify-center icon-transparent-bg delete ${isProcessing && 'animate-bounce cursor-not-allowed opacity-50'}`"
                @click="isProcessing ? null : cancelEdit(row)"
              >
                <img
                  :src="require('@/assets/shipo-icon-close-circle.svg')"
                  alt="cancel"
                >
              </div>
            </template>
            <template v-else>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'edit')"
                class="flex items-center justify-center icon-transparent-bg"
                @click="startEdit(row)"
              >
                <img :src="require('@/assets/shipo-icon-edit.svg')">
              </div>
              <div
                v-if="isUserCanAccessMenu(permission.name, 'delete')"
                class="flex items-center justify-center icon-transparent-bg"
                @click="popUp = { isShown: true, tempId: row.id, tempName: row.date }"
              >
                <img :src="require('@/assets/shipo-icon-delete.svg')">
              </div>
            </template>
          </div>
        </template>
        <template #date="{ row }">
          <template v-if="row.isEditing">
            <div class="relative">
              <div>
                <date-picker
                  v-model="row.editForm.date.value"
                  type="date"
                  format="DD-MMM-YYYY"
                  value-type="DD-MMM-YYYY"
                  :class="{ 'is-not-valid': !row.editForm.date.isValid }"
                  placeholder="Date"
                  :disabled="isProcessing"
                />
              </div>
              <span
                v-if="!row.editForm.date.value"
                class="text-danger text-sm absolute-bottom-5 left-0"
              >*Required</span>
            </div>
          </template>
          <template v-else>
            {{ row.date || '-' }}
          </template>
        </template>
        <template #open_bridge="{ row }">
          <template v-if="row.isEditing">
            <div class="relative">
              <date-picker
                v-model="row.editForm.open_bridge.value"
                type="time"
                format="HH:mm"
                value-type="format"
                :class="{ 'is-not-valid': !row.editForm.open_bridge.isValid }"
                placeholder="Select Time"
                :disabled="isProcessing"
              />
              <span
                v-if="!row.editForm.open_bridge.value"
                class="text-danger text-sm absolute-bottom-5 left-0"
              >*Required</span>
            </div>
          </template>
          <template v-else>
            {{ row.open_bridge || '-' }}
          </template>
        </template>
        <template #close_bridge="{ row }">
          <template v-if="row.isEditing">
            <div class="relative">
              <date-picker
                v-model="row.editForm.close_bridge.value"
                type="time"
                format="HH:mm"
                value-type="format"
                :class="{ 
                  'is-not-valid': !row.editForm.close_bridge.isValid || 
                    (row.editForm.close_bridge.value && row.editForm.open_bridge.value && 
                      !isCloseTimeAfterOpenTime(row.editForm.open_bridge.value, row.editForm.close_bridge.value))
                }"
                placeholder="Select Time"
                :disabled="isProcessing"
              />
              <span
                v-if="!row.editForm.close_bridge.value"
                class="text-danger text-sm absolute-bottom-5 left-0"
              >*Required</span>
              <span
                v-else-if="row.editForm.close_bridge.value && row.editForm.open_bridge.value && 
                  !isCloseTimeAfterOpenTime(row.editForm.open_bridge.value, row.editForm.close_bridge.value)"
                class="text-danger text-sm absolute-bottom-5 left-0"
              >Close time must be after open time</span>
            </div>
          </template>
          <template v-else>
            {{ row.close_bridge || '-' }}
          </template>
        </template>
      </data-table>
      <table-bottom 
        class="mt-7"
        @fetch="fetchBridgeSchedule()" 
      />
    </div>
    <pop-up
      :active.sync="popUp.isShown"
      :is-warning="true"
      :title="popUp.isDuplicateDate ? 'Duplicate Date Found' : 'Delete Bridge Schedule'"
      :left-button="popUp.isDuplicateDate ? 'Cancel' : 'Cancel'"
      :right-button="popUp.isDuplicateDate ? 'Replace' : 'Yes, Delete'"
      :is-busy="isProcessing"
      @close="popUp = { isShown: false, tempId: null, tempName: '', isDuplicateDate: false, duplicateData: null }"
      @leftButton="popUp = { isShown: false, tempId: null, tempName: '', isDuplicateDate: false, duplicateData: null }"
      @rightButton="popUp.isDuplicateDate ? replaceDuplicateSchedule() : deleteLocation(popUp.tempId)"
    >
      <template v-if="popUp.isDuplicateDate">
        <p class="text-center mt-1">
          A bridge schedule already exists for "{{ popUp.tempName }}".
        </p>
        <p class="text-center">
          Do you want to replace it with the new schedule?
        </p>
      </template>
      <template v-else>
        <p class="text-center mt-1">
          Are you sure want to delete bridge schedule "{{ popUp.tempName }}"?
        </p>
        <p class="text-center">
          This action cannot be undone
        </p>
      </template>
    </pop-up>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

import DataTable from '@/components/dataTable'
import DatePicker from '@/components/datePicker'
import PopUp from '@/components/popUp'
import TableBottom from '@/components/tableBottom'
import TableTop from '@/components/tableTop'
import { PAGE_TITLE } from '@/fixtures/Constants'

import downloadUtils from '../../../utils/downloadUtils'


export default {
  components: {
    DataTable,
    TableBottom,
    TableTop,
    PopUp,
    DatePicker
  },
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.$route.meta.title}`
    }
  },
  data() {
    return {
      isDownload: false,
      isBusy: false,
      isProcessing: false,
      filters: {
        sort_by: '',
        sort_dir: '',
        month_year: moment().format('MMM-YYYY')
      },
      tableHeaders: [
        { key: 'no', label: 'No', sortable: false, width: '20px' },
        { key: 'date', label: 'Date', sortable: true, width: '160px' },
        { key: 'open_bridge', label: 'Open Bridge (WITA)', sortable: true, width: '180px' },
        { key: 'close_bridge', label: 'Close Bridge (WITA)', sortable: true, width: '190px' },
        { key: 'modified_by', label: 'Modified By', width: '200px' }
      ],
      bridgeScheduleData: [],
      isAdding: false,
      isEditing: false,
      editForm: {
      },
      popUp: {
        isShown: false,
        tempId: null,
        tempName: '',
        isDuplicateDate: false,
        duplicateData: null
      },
      allBridgeScheduleData: []
    }
  },
  computed: {
    ...mapGetters({
      currentPage: 'Table/currentPage',
      pageSize: 'Table/pageSize',
      bridgeSchedule: 'BridgeSchedule/bridgeSchedule',
      bridgeScheduleFiles: 'BridgeSchedule/bridgeScheduleFiles'
    }),
    permission() {
      return { page: this.$route.meta.permission.page, name: this.$route.meta.permission.name }
    },
    isActionColumnVisible() {
      return this.isUserCanAccessMenu(this.permission.name, 'edit') || this.isUserCanAccessMenu(this.permission.name, 'delete')
    }
  },
  watch: {
    bridgeSchedule: {
      handler(val) {
        if (val) {
          this.bridgeScheduleData = val.map(item => ({
            ...item,
            isEditing: false,
            editForm: null
          }))
        }
      }
    },
    isDownload: {
      handler(val) {
        if (!!val) {
          this.downloadBridgeSchedule()
        }
      }
    },
    bridgeScheduleFiles: {
      handler(val) {
        if (!this.isEmpty(val)) {
          downloadUtils(val, `Bridge Schedule ${this.filters.month_year}.xlsx`)
          // Reset the export file state
          this.$store.dispatch('BridgeSchedule/resetBridgeScheduleFiles');
        }
      }
    },
    filters: {
      deep: true,
      handler() {
        this.fetchBridgeSchedule()
      }
    },
    isActionColumnVisible: {
      immediate: true,
      handler(val) {
        const index = this.tableHeaders.findIndex(header => header.key === 'action');
        if (val && index === -1) {
          this.tableHeaders.splice(1, 0, { key: 'action', label: 'Action', sortable: false, width: '75px' });
        } else if (!val && index !== -1) {
          this.tableHeaders.splice(index, 1);
        }
      }
    }
  },
  mounted() {
    this.fetchBridgeSchedule()
  },
  methods: {
    async fetchBridgeSchedule() {
      try {
        this.isBusy = true
        const apiFilters = {
          date: this.filters.month_year,
          sort_dir: this.filters.sort_dir || 'asc',
          sort_by: this.filters.sort_by || 'date',
          page: this.currentPage || 1,
          limit: this.pageSize || 10
        };

        await this.$store.dispatch('BridgeSchedule/fetchBridgeSchedule', apiFilters)

        this.isAdding = false
        this.isBusy = false
      } catch (e) {
        this.isBusy = false
        this.showFailedNotification(this, 'Failed to fetch Bridge Schedule list, please try again')
      }
    },
    async fetchAllBridgeScheduleData() {
      try {
        const apiFilters = {
          sort_dir: 'asc',
          sort_by: 'date',
          page: 1,
          limit: 1000
        };

        const data = await this.$store.dispatch('BridgeSchedule/fetchAllBridgeSchedule', apiFilters)
        this.allBridgeScheduleData = data.data || []
      } catch (e) {
        this.allBridgeScheduleData = []
      }
    },
    sort(sortBy, sortDir) {
      this.filters.sort_by = sortBy
      this.filters.sort_dir = sortDir
      this.fetchBridgeSchedule()
    },
    resetFilters() {
      this.filters = {
        sort_by: 'date',
        sort_dir: 'asc',
        month_year: moment().format('MMM-YYYY')
      }
      this.$store.dispatch('Table/resetConfig')
      this.$refs.tabletop && this.$refs.tabletop.$emit('reset-search')
      this.fetchBridgeSchedule()
    },
    startAdd() {
      if (this.bridgeScheduleData.some(r => r.isEditing)) {
        this.showWarningNotification(this, 'Only one action can be active at a time. Please save your changes first')
        return
      }

      const newRow = {
        id: `new-${Date.now()}`,
        date: '',
        open_bridge: '',
        close_bridge: '',
        isEditing: true,
        editForm: {
          date: { value: '', isValid: true },
          open_bridge: { value: '', isValid: true },
          close_bridge: { value: '', isValid: true }
        }
      };

      this.isAdding = true;
      this.bridgeScheduleData.unshift(newRow);
    },
    startEdit(row) {
      if (this.bridgeScheduleData.some(r => r.isEditing)) {
        this.showWarningNotification(this, 'Only one action can be active at a time. Please save your changes first')
        return
      }

      const index = this.bridgeScheduleData.findIndex(item => item.id === row.id);
      if (index !== -1) {
        this.$set(this.bridgeScheduleData[index], 'isEditing', true);
        this.$set(this.bridgeScheduleData[index], 'editForm', {
          date: { value: row.date, isValid: true },
          open_bridge: { value: row.open_bridge, isValid: true },
          close_bridge: { value: row.close_bridge, isValid: true }
        });
      }
    },
    startDelete(row) {
      this.popUp = {
        isShown: true,
        tempId: row.id
      }
    },
    async saveEdit(row) {
      try {
        if (!row.editForm.date.value) {
          this.showFailedNotification(this, 'Date is required')
          return
        }
        if (!row.editForm.open_bridge.value) {
          this.showFailedNotification(this, 'Open Bridge time is required')
          return
        }
        if (!row.editForm.close_bridge.value) {
          this.showFailedNotification(this, 'Close Bridge time is required')
          return
        }

        if (!this.isCloseTimeAfterOpenTime(row.editForm.open_bridge.value, row.editForm.close_bridge.value)) {
          this.showFailedNotification(this, 'Close Bridge time must be after Open Bridge time')
          return
        }

        this.isProcessing = true
        await this.fetchAllBridgeScheduleData()
        const existingSchedule = this.allBridgeScheduleData.find(item => 
          item.id !== row.id && 
          moment(item.date).format('DD-MMM-YYYY') === moment(row.editForm.date.value).format('DD-MMM-YYYY')
        )

        if (existingSchedule) {
          this.popUp = {
            isShown: true,
            tempId: existingSchedule.id,
            tempName: moment(row.editForm.date.value).format('DD MMM YYYY'),
            isDuplicateDate: true,
            duplicateData: {
              date: row.editForm.date.value,
              open_bridge: row.editForm.open_bridge.value,
              close_bridge: row.editForm.close_bridge.value
            }
          }
          return
        }
        if(this.isAdding) {
          await this.saveBridgeScheduleData(row)
        } else {
          await this.$store.dispatch('BridgeSchedule/putBridgeSchedule', {
            id: row.id,
            form: {
              date: moment(row.editForm.date.value).format('YYYY-MM-DD'),
              open_bridge: row.editForm.open_bridge.value,
              close_bridge: row.editForm.close_bridge.value
            }
          })
        }
        await this.saveBridgeScheduleData(row)
        this.isProcessing = false
      } catch (error) {
        this.isProcessing = false
        this.showFailedNotification(this, 'Failed to save bridge schedule, please try again')
      }
    },
    async saveBridgeScheduleData(row) {
      try {
        this.isProcessing = true
        await this.$store.dispatch('BridgeSchedule/postBridgeSchedule', {
          date: moment(row.editForm.date.value).format('YYYY-MM-DD'),
          open_bridge: row.editForm.open_bridge.value,
          close_bridge: row.editForm.close_bridge.value
        })
        this.isProcessing = false
        this.cancelAllEdits()
        this.fetchBridgeSchedule()
        this.showSuccessNotification(this, 'Bridge schedule saved successfully')
      } catch (error) {
        this.isProcessing = false
        this.showFailedNotification(this, 'Failed to save bridge schedule, please try again')
      }
    },
    async replaceDuplicateSchedule() {
      try {
        const duplicateData = this.popUp.duplicateData
        this.isProcessing = true
        await this.$store.dispatch('BridgeSchedule/putBridgeSchedule', {
          id: this.popUp.tempId,
          form: {
            date: moment(duplicateData.date).format('YYYY-MM-DD'),
            open_bridge: duplicateData.open_bridge,
            close_bridge: duplicateData.close_bridge
          }
        })
        this.cancelAllEdits()
        this.fetchBridgeSchedule()
        this.isProcessing = false
        this.showSuccessNotification(this, 'Bridge schedule replaced successfully')
        this.popUp = { isShown: false, tempId: null, tempName: '', isDuplicateDate: false, duplicateData: null }
      } catch (error) {
        this.isProcessing = false
        this.showFailedNotification(this, 'Failed to replace bridge schedule, please try again')
      }
    },
    cancelEdit(row) {
      const index = this.bridgeScheduleData.findIndex(item => item.id === row.id)
      if (index !== -1) {
        if (row.id.toString().startsWith('new-')) {
          this.bridgeScheduleData.splice(index, 1)
        } else {
          this.$set(this.bridgeScheduleData[index], 'isEditing', false)
          this.$set(this.bridgeScheduleData[index], 'editForm', null)
        }
      }
    },
    cancelAllEdits() {
      this.bridgeScheduleData.forEach((item, index) => {
        if (item.isEditing) {
          if (item.id.toString().startsWith('new-')) {
            this.bridgeScheduleData.splice(index, 1)
          } else {
            this.$set(this.bridgeScheduleData[index], 'isEditing', false)
            this.$set(this.bridgeScheduleData[index], 'editForm', null)
          }
        }
      })
    },
    async deleteLocation(id) {
      try {
        this.isProcessing = true
        await this.$store.dispatch('BridgeSchedule/deleteBridgeSchedule', id)
        this.fetchBridgeSchedule()
        this.isProcessing = false
        this.showSuccessNotification(this, 'Bridge schedule deleted successfully')
        this.popUp = { isShown: false, tempId: null, tempName: '', isDuplicateDate: false, duplicateData: null }
      } catch (error) {
        this.isProcessing = false
        this.showFailedNotification(this, 'Failed to delete bridge schedule, please try again')
      }
    },
    async downloadBridgeSchedule() {
      try {
        this.isBusy = true
        await this.$store.dispatch('BridgeSchedule/downloadBridgeSchedule', {
          sort_dir: this.filters.sort_dir || 'asc',
          sort_by: this.filters.sort_by || 'date',
          date: this.filters.month_year
        }, {
          headers: {
            accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          },
          responseType: 'blob'
        });
        this.isBusy = false
        this.isDownload = false;
      } catch (error) {
        this.isBusy = false
        this.isDownload = false;
        this.showFailedNotification(this, 'Failed to download Bridge Schedule, please try again');
      }
    },
    isCloseTimeAfterOpenTime(openTime, closeTime) {
      if (!openTime || !closeTime) return true;
      
      const openMoment = moment(openTime, 'HH:mm');
      const closeMoment = moment(closeTime, 'HH:mm');
      
      return closeMoment.isAfter(openMoment);
    }
  }
}
</script>

<style scoped>
.filter-container {
  @apply w-full p-3 mt-5 flex flex-row items-center bg-white rounded-lg;
}

.icon-transparent-bg {
  @apply cursor-pointer;
  @apply min-w-8;
  @apply h-8;
  @apply bg-primary;
  border-radius: 0.5rem;

  &.complete {
    background-color: #D1F9E3;
  }

  &.delete {
    background-color: rgba(255, 99, 123, 0.16);
  }
}
</style>
